/**
 * Payment and storefront catalog API paths (baseURL is prefixed by axios).
 * Regression: POST /payments/order expects amount (INR), courseId, paymentMode, planType,
 * installmentPlanId (installment), installmentIndex, totalInstallments, optional couponCode.
 * POST /payments/verify expects razorpay_order_id, razorpay_payment_id, razorpay_signature.
 * Razorpay client `amount` from create-order response is in paise.
 */

/**
 * @typedef {Object} CheckoutCourseDto
 * @property {string} [_id]
 * @property {string} [title]
 * @property {number} [price]
 * @property {string} [description]
 * @property {string[]} [courseImage]
 * @property {boolean} [isPublished]
 */

/**
 * @typedef {Object} CheckoutDataDto
 * @property {CheckoutCourseDto} course
 * @property {object[]} installmentPlans
 * @property {object|null} subscription
 */

export const paymentsApi = {
  checkoutData: (courseId) => `/payments/checkout-data/${courseId}`,
  order: "/payments/order",
  verify: "/payments/verify",
  subscriptionCatalog: "/payments/subscription-catalog",
  installmentPlans: (courseId) => `/payments/installment-plans/${courseId}`,
  userInstallmentTimeline: (courseId) => `/user/installments/${courseId}/timeline`,
  userCourseDetail: (courseId) => `/user/courses/${courseId}/detail`,
};
